var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetflix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 112 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38:455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4003 28.0663C13.7155 28.3595 12.0011 28.4474 10.2275 28.6816L4.81808 12.9786V29.3555C3.13327 29.5313 1.59622 29.7656 0 30V0H4.49312L10.6413 17.0217V0H15.4003V28.0663ZM24.7115 10.9863C26.5443 10.9863 29.3524 10.8984 31.0372 10.8984V15.5858C28.9384 15.5858 26.4852 15.5858 24.7115 15.6737V22.6465C27.4902 22.4708 30.2688 22.2362 33.0767 22.1483V26.6597L19.9819 27.6854V0H33.0767V4.68751H24.7115V10.9863ZM50.6645 4.68762H45.7577V26.2501C44.1615 26.2501 42.5653 26.2501 41.0284 26.3085V4.68762H36.1216V0H50.6647L50.6645 4.68762ZM58.3498 10.6642H64.8234V15.3516H58.3498V25.9864H53.7087V0H66.9221V4.68751H58.3498V10.6642ZM74.6074 21.8848C77.2974 21.9432 80.0167 22.1486 82.6476 22.2948V26.9238C78.4207 26.66 74.1937 26.3966 69.8781 26.3085V0H74.6074V21.8848ZM86.638 27.2461C88.1455 27.3341 89.7418 27.422 91.2788 27.5975V0H86.638V27.2461ZM112 0L105.999 14.2676L112 30C110.226 29.7656 108.453 29.4433 106.679 29.1503L103.28 20.4786L99.8219 28.4474C98.1071 28.1542 96.4518 28.0663 94.7377 27.8319L100.827 14.0917L95.3286 0H100.413L103.516 7.88088L106.827 0H112V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38:455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflix);
export default __webpack_public_path__ + "static/media/netflix.bea5927a.svg";
export { ForwardRef as ReactComponent };